import React, { useRef, useState } from 'react';
import { FilterType, Region } from '../search/FilterData';
import { isLogin } from '../../utils/auth';
import { useModal } from '../../context/ModalContext';
import { useNavigate } from 'react-router-dom';
import SearchFilter from '../search/filter/SearchFilter';
import styled from 'styled-components';

function Filter() {
  const { modalDispatch } = useModal();
  const navigate = useNavigate();

  const [filters, setFilters] = useState<FilterType>({
    type: 'a',
    year: '',
    caseNumber: '',
    regionOrCourt: 'r',
    region: [] as Region[],
    address: '',
    court: '',
    itemStatus: [],
    multiItemStatus: [],
    appraisalPrice: { min: '', max: '' },
    minPrice: { min: '', max: '' },
    saleDate: { start: '', end: '' },
    approvalDate: { start: '', end: '' },
    buildingArea: { min: '', max: '' },
    landArea: { min: '', max: '' },
    bidno: '',
    progressStatus: '진행',
    useArea: [],
    multiUseArea: [],
    specialConditionViewOption: 'o',
    specialItemCondition: [],
    multiSpecialItemCondition: [],
    holdingCompany: [],
    multiHoldingCompany: [],
  });

  const handleReset = () => {
    setFilters({
      type: 'a',
      year: '',
      caseNumber: '',
      regionOrCourt: 'r',
      region: [] as Region[],
      address: '',
      court: '',
      itemStatus: [],
      multiItemStatus: [],
      appraisalPrice: { min: '', max: '' },
      minPrice: { min: '', max: '' },
      saleDate: { start: '', end: '' },
      approvalDate: { start: '', end: '' },
      buildingArea: { min: '', max: '' },
      landArea: { min: '', max: '' },
      bidno: '',
      progressStatus: '진행',
      useArea: [],
      multiUseArea: [],
      specialConditionViewOption: 'o',
      specialItemCondition: [],
      multiSpecialItemCondition: [],
      holdingCompany: [],
      multiHoldingCompany: [],
    });
  };

  const prevFiltersRef = useRef(filters);

  const isOnlyProgressStatusChangedToAll = () => {
    const prev = prevFiltersRef.current;

    if (filters.progressStatus !== '전체') return false;
    const { progressStatus: _, region, ...rest } = filters;
    const { progressStatus: __, region: prevRegion, ...prevRest } = prev;

    const same = JSON.stringify(rest) === JSON.stringify(prevRest);
    const isRegionChange =
      region.length === 0 ||
      (region.length === 1 &&
        region[0].sido === '' &&
        region[0].sigungu === '' &&
        region[0].emd === '');

    return same && isRegionChange;
  };

  const handleSearch = () => {
    if (!isLogin()) {
      modalDispatch({ type: 'USER_ALERT', payload: 'guest' });
      return;
    }

    if (isOnlyProgressStatusChangedToAll()) {
      window.alert(
        `진행단계 '전체'를 선택할 경우, 추가 조건 입력이 필요합니다.\n검색 조건을 추가해주세요.`,
      );
      return;
    }
    navigate(
      `/search?type=e&itemType=${filters.type}&regionOrCourt=${filters.regionOrCourt}&options=${JSON.stringify(filters)}`,
    );
  };

  const handleMoreOpen = () => {
    navigate(
      `/search?type=c&itemType=${filters.type}&regionOrCourt=${filters.regionOrCourt}&options=${JSON.stringify(filters)}`,
    );
  };

  const handleMySearchFilter = () => {
    if (!isLogin()) {
      modalDispatch({ type: 'USER_ALERT', payload: 'guest' });
      return;
    }

    navigate(`/search/mySearchOption?type=${filters.type}`);
  };

  return (
    <Content>
      <SearchFilter
        filters={filters}
        setFilters={setFilters}
        moreOptionCount={0}
        isMain
        handleMoreOpen={handleMoreOpen}
        hasSearchButton
        handleReset={handleReset}
        handleSearch={handleSearch}
      />
      <MyFilter onClick={handleMySearchFilter}>내 검색조건 불러오기</MyFilter>
    </Content>
  );
}

export default Filter;

const Content = styled.div`
  display: flex;
  width: 100%;
  padding: 24px 16px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  flex: 1 0 0;
`;

const MyFilter = styled.div`
  display: flex;
  width: 100%;
  height: 44px;
  padding: 12px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border-radius: 8px;
  background: rgba(112, 115, 124, 0.08);

  color: #222;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;
